export default __webpack_public_path__ + "static/media/img-brand-assets-banner-new-mobile.caf68457.png";